import Vue from "vue";
import router from "@/router";
import helper from "@/config/helper";

const state = {
	email:	"",
	code:	"",
	token:	"",
}

const actions = {
	startLocalStorage({commit, getters}){
		const email	= localStorage.getItem("pagstream_email");
		const code	= localStorage.getItem("pagstream_code");
		const token	= localStorage.getItem("pagstream_token");

		if(email){
			commit("setEmail", email);
		}

		if(code){
			commit("setCode", code);
		}

		if(token){
			commit("setToken", token);
		}

		return getters.getCredentials;
	},

	sendVerificationCode({commit, state, rootGetters}){
		commit("setErroToken", false, { root: true });

		var data = new FormData();
		data.append("email", state.email);
		data.append("method", "sendVerificationCode");

		const confirmation = rootGetters["customization/getConfirmation"];

		helper
			.axios()
			.post("", data)
			.then(() => {
				const query = router.currentRoute.query;
				router.push({ name: 'login_code', query }).catch(() => {});

				if(confirmation) {
					Vue.$toast.success("Um novo código foi enviado para o seu e-mail.", { position: 'bottom' });
					commit('customization/setConfirmation', false, { root: true });
				}
			})
			.catch((error) => {
				helper.callback_error(error);
			})
			.finally(() => {
				commit("setLoading", false, { root: true });
			});
	},

	validateCode({commit, state}){
		var data = new FormData();

		data.append("email",	state.email);
		data.append("code",		state.code);
		data.append("method",	"validateCode");

		commit("setLoading", true, { root: true });

		helper
			.axios()
			.post("", data)
			.then((response) => {
				const data = response.data;

				if(data.token){
					commit("setToken", data.token);
					const query = router.currentRoute.query;
					router.push({ name: "subscriptions", query }).catch(() => {});
				}
			})
			.catch((error) => {
				commit("setErroToken", true, { root: true });
				helper.callback_error(error);
			})
			.finally(() => {
				commit("setLoading", false, { root: true });
			});
	}
}

const mutations = {
	setEmail(state, content){
		if(!content){
			localStorage.removeItem("pagstream_email");
			state.email = "";
			return;
		}

		content = content.toLowerCase();
		state.email = content;
		localStorage.setItem("pagstream_email", content);
	},

	setCode(state, content){
		if (!content) {
			localStorage.removeItem("pagstream_code");
			state.code = "";
			return;
		}

		if (content.length == 4) {
			state.code = content;
			localStorage.setItem("pagstream_code", content);
		}
	},

	setToken(state, content){
		if (!content) {
			localStorage.removeItem("pagstream_token");
			state.token = "";
			return;
		}

		state.token = content;
		localStorage.setItem("pagstream_token", content);
	},

	logout(state) {
		const query = router.currentRoute.query;
		router.push({ name: "login", query }).catch(() => {});
		
		localStorage.setItem("pagstream_email",	'');
		localStorage.setItem("pagstream_code",	'')
		localStorage.setItem("pagstream_token",	'');

		state.email	= '';
		state.code	= '';
		state.token = '';
	}
}

const getters = {
	getCredentials(state){
		const credentials = {
			email: state.email,
			code: state.code,
			token: state.token
		}

		return credentials;
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}